<template>
    <DCard
        :title="__('orders.show.contacts')"
        :title-middle="__('orders.show.current_contacts')"
        :main-title-has-slot="true"
        padding
    >
        <template #titleHasSlot>
            <DSwitch
                color="success"
                variant="3d"
                :disabled="isInLoadingState"
                :checked="showSection"
                @update:checked="onCheck"
            />
        </template>
        <div v-if="showSection">
            <DRow
                v-for="(contactRow, key) in contacts"
                :key="key"
            >
                <DCol v-if="contactRow.order">
                    <DCardBody>
                        <DRow>
                            <span>{{ contactRow.order.title }} {{ contactRow.order.first_name }} {{ contactRow.order.last_name }} {{ setDateFormatEuropeBerlin(contactRow.order.birth_date) }}</span>
                        </DRow>
                        <DRow>
                            <span>
                                <span class="label">{{ __('orders.show.phone_number') }}:</span>{{ contactRow.order.phone }} <span class="label">{{ __('orders.show.email') }}:</span>{{ contactRow.order.email }}
                            </span>
                        </DRow>
                        <DRow>
                            <span>
                                <span class="label">{{ __('orders.show.email_marketing') }}:</span> {{ contactRow.order.advertising_consent ? __('orders.show.marketing_allowed') : __('orders.show.marketing_not_allowed') }}
                                <span class="label">{{ __('orders.show.telemarketing') }}:</span> {{ contactRow.order.telemarketing_consent ? __('orders.show.marketing_allowed') : __('orders.show.marketing_not_allowed') }}
                            </span>
                        </DRow>
                    </DCardBody>
                </DCol>
                <DCol v-else />
                <DCol v-if="contactRow.database">
                    <DCardBody>
                        <DRow>
                            <span>{{ contactRow.database.title }} {{ contactRow.database.firstname }} {{ contactRow.database.lastname }} {{ contactRow.database.postfix_title }} {{ setDateFormatEuropeBerlin(contactRow.database.birthdate) }}</span>
                        </DRow>
                        <DRow>
                            <span>
                                <span class="label">{{ __('orders.show.phone_number') }}:</span>{{ contactRow.database.phone }} <span class="label">{{ __('orders.show.email') }}:</span>{{ contactRow.database.email }}
                            </span>
                        </DRow>
                        <DRow>
                            <span>
                                <span class="label">{{ __('orders.show.email_marketing') }}:</span> {{ contactRow.database.email_newsletter ? __('orders.show.marketing_allowed') : __('orders.show.marketing_not_allowed') }}
                                <span class="label">{{ __('orders.show.telemarketing') }}:</span> {{ contactRow.database.telemarketing ? __('orders.show.marketing_allowed') : __('orders.show.marketing_not_allowed') }}
                            </span>
                        </DRow>
                    </DCardBody>
                </DCol>
                <DCol v-else />
            </DRow>
        </div>
    </DCard>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
    orderContacts: {
        type: Array,
        default () { return [] }
    },
    databaseContacts: {
        type: Array,
        default () { return [] }
    }
})

const showSection = ref(true)

const contacts = computed(() => {
    const databaseContacts = []
    const newContacts = []
    const contacts = []

    for (let i = 0; i < props.databaseContacts.length; ++i) {
        databaseContacts[props.databaseContacts[i].id] = props.databaseContacts[i]
    }
    for (let i = 0; i < props.orderContacts.length; ++i) {
        if (props.orderContacts[i].external_id === null) {
            newContacts.push({
                order: props.orderContacts[i],
                database: null
            })
        } else {
            if (databaseContacts[props.orderContacts[i].external_id]) {
                contacts.push({
                    order: props.orderContacts[i],
                    database: databaseContacts[props.orderContacts[i].external_id]
                }
                )
                delete databaseContacts[props.orderContacts[i].external_id]
            } else {
                contacts.push({
                    order: props.orderContacts[i],
                    database: null
                }
                )
            }
        }
    }
    contacts.unshift(...newContacts)
    for (let i = 0; i < databaseContacts.length; ++i) {
        contacts.push({
            order: null,
            database: databaseContacts[i]
        })
    }
    return contacts
})

function onCheck (value) {
    showSection.value = value
}
</script>

<style scoped lang="scss">
    span.label {
        font-weight: bold;
    }
</style>
